import { createApi } from '@blockworks/platform/api';
import { GetPriceChartRequest, GetPriceChartResponse } from '@blockworks/platform/api/coingecko';

import { INTERNAL_PRICE_CHART_ENDPOINTS } from './internal-price-chart.model';

const internalPriceChartApi = createApi(build => ({
    get: {
        priceChart: build<GetPriceChartResponse, Omit<GetPriceChartRequest, 'coingeckoApiKey'>>({
            cachePrefix: 'assets-price-chart',
            baseUrl: 'same-origin',
            query: params => {
                return {
                    params,
                    uri: INTERNAL_PRICE_CHART_ENDPOINTS.GET.PRICE_CHART(),
                };
            },
        }),
    },
}));

export { internalPriceChartApi };
